import { render } from "./InvitationWeddingListPage.vue?vue&type=template&id=2e8b85aa&lang=true"
import script from "./InvitationWeddingListPage.vue?vue&type=script&lang=js"
export * from "./InvitationWeddingListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__